import { render, staticRenderFns } from "./SegmentSendMessage.vue?vue&type=template&id=007215cc&scoped=true&lang=pug&"
import script from "./SegmentSendMessage.vue?vue&type=script&lang=js&"
export * from "./SegmentSendMessage.vue?vue&type=script&lang=js&"
import style0 from "./SegmentSendMessage.vue?vue&type=style&index=0&id=007215cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007215cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBreadcrumbs,VBtn,VCard,VCol,VContainer,VDivider,VRow,VTextField})
